import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Row, Col, Card, CardBody,
} from 'reactstrap';
import { ButtonLink } from 'components/Button';
import { PhoneIcon } from './components/Icons';
import './style.scss';

const APPS = [
  { name: 'Google Authenticator' },
  { name: 'Microsoft Authenticator' },
  { name: 'Twilio Authy' },
];

/**
 * "What's an authenticator app?" — an educational screen for users new to TOTP
 * apps. Lists supported apps and routes to the setup screen.
 */
const WhatIsAuthenticatorApp = () => {
  const navigate = useNavigate();

  return (
    <div className="two-factor-page">
      <Container fluid>
        <Row>
          <Col>
            <Card className="tf-card">
              <CardBody className="p-4">
                <h3 className="tf-title">What&apos;s an authenticator app?</h3>
                <p className="tf-subtitle">
                  It&apos;s a free app on your phone that generates a new 6-digit code every 30
                  seconds. You&apos;ll enter that code instead of waiting on a text message. It
                  works even without cell signal or WiFi, and it can&apos;t be intercepted the way
                  a text can.
                </p>

                <p className="tf-code-label mb-2">Any of these work:</p>
                {APPS.map((app) => (
                  <div className="tf-option tf-option--static" key={app.name}>
                    <span className="tf-option__icon"><PhoneIcon /></span>
                    <span className="tf-option__body">
                      <span className="tf-option__title mb-0">{app.name}</span>
                    </span>
                  </div>
                ))}

                <div className="text-center mt-3">
                  <ButtonLink className="tf-link" onClick={() => navigate(-1)}>
                    Back
                  </ButtonLink>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WhatIsAuthenticatorApp;
